import { render, staticRenderFns } from "./AdminServiceBookDashboard.vue?vue&type=template&id=53c361fd&scoped=true"
import script from "./AdminServiceBookDashboard.vue?vue&type=script&lang=js"
export * from "./AdminServiceBookDashboard.vue?vue&type=script&lang=js"
import style0 from "./AdminServiceBookDashboard.vue?vue&type=style&index=0&id=53c361fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c361fd",
  null
  
)

export default component.exports